import React from 'react';
import {
    ErrorBoundary,
    Provider,
} from '@rollbar/react';
import { appConfig } from './appConfig';

const ErrorDisplay: React.FC = React.memo(() => (
    <h1>Something went wrong.</h1>
));

const Rollbar: React.FC = React.memo(({
    children,
}) => (
    <Provider
        config={{
            accessToken: appConfig.ROLLBAR_ACCESS_TOKEN,
            captureUncaught: true,
            captureUnhandledRejections: true,
            payload: {
                environment: 'production',
                client: { javascript: { source_map_enabled: true } },
            },
        }}
    >
        <ErrorBoundary fallbackUI={ErrorDisplay}>
            {children}
        </ErrorBoundary>
    </Provider>
));

export default Rollbar;
